var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-secondary d-flex justify-content-between rounded"},[_c('div',{staticClass:"p-2"},[_vm._v(" "+_vm._s(_vm.choiceOff)+" ")]),_c('div',{staticClass:"p-2"},[_vm._v(" "+_vm._s(_vm.choiceOn)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }